import { Brand, DescribedImage, EntityType, Hall } from '@planone/bau365/util-fair-data';

import { WatchlistItem, WatchlistItemIdentity } from '../watchlist/watchlist.models';

export interface EnrichmentData extends WatchlistItemIdentity {
  data?: EnrichedData;
  deleted?: boolean;
  hasError?: boolean;
}

export interface EnrichedData {
  name: string;
  image?: DescribedImage;
  exhibitorId?: string;
  exhibitorName?: string;
  exhibitionHalls?: Hall[];
  starts_at?: string;
  ends_at?: string;
  brand?: Brand;
}

export type EnrichedWatchlistItem = WatchlistItem & EnrichmentData;

export enum ItemCategory {
  all = 'ALL',
  event = 'EVENT',
  exhibitor = 'EXHIBITOR',
  post = 'POST',
  product = 'PRODUCT',
  brand = 'BRAND',
}

export const ItemCategories: ItemCategory[] = [
  ItemCategory.all,
  ItemCategory.exhibitor,
  ItemCategory.product,
  ItemCategory.event,
  ItemCategory.post,
  ItemCategory.brand,
];

export interface ValidCategoryEntityTypes {
  category: ItemCategory;
  entityTypes: EntityType[];
}

export const CategoryMapping: ValidCategoryEntityTypes[] = [
  {
    category: ItemCategory.all,
    entityTypes: [EntityType.event, EntityType.exhibitor, EntityType.post, EntityType.product, EntityType.brand],
  },
  {
    category: ItemCategory.event,
    entityTypes: [EntityType.event],
  },
  {
    category: ItemCategory.exhibitor,
    entityTypes: [EntityType.exhibitor],
  },
  {
    category: ItemCategory.post,
    entityTypes: [EntityType.post],
  },
  {
    category: ItemCategory.product,
    entityTypes: [EntityType.product],
  },
  {
    category: ItemCategory.brand,
    entityTypes: [EntityType.brand],
  },
];
